/* Palsora header, "side menu" layout: solid bar once the page scrolls, and the side menu (open/close, Esc, focus trap). */
(function () {
  function init(scope) {
    var hdr = (scope || document).querySelector('.pals-header--side');
    if (!hdr || hdr.getAttribute('data-pals-side-init')) return;
    hdr.setAttribute('data-pals-side-init', '1');

    var ticking = false;
    function setScrolled() {
      hdr.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(setScrolled); }
    }, { passive: true });
    setScrolled();

    var btn = hdr.querySelector('[data-pals-side-open]');
    var side = btn && document.getElementById(btn.getAttribute('aria-controls'));
    if (!side) return;
    var panel = side.querySelector('.pals-side__panel');
    var lastFocus = null, hideTimer = null;

    function isOpen() { return side.classList.contains('is-open'); }
    function focusables() {
      return Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled])'), function (el) {
        return el.offsetParent !== null;
      });
    }
    function open() {
      clearTimeout(hideTimer);
      lastFocus = document.activeElement;
      side.hidden = false;
      void side.offsetWidth; // let the closed state paint first so the panel slides in
      side.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('pals-side-lock');
      var first = panel.querySelector('.pals-side__x') || panel;
      first.focus({ preventScroll: true });
    }
    function close(keepFocus) {
      if (!isOpen()) return;
      side.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('pals-side-lock');
      hideTimer = setTimeout(function () { side.hidden = true; }, 340);
      if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOpen()) close(); else open();
    });
    side.addEventListener('click', function (e) {
      if (e.target.closest('[data-pals-side-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    // coming back with the browser's back button: start with the menu closed
    window.addEventListener('pageshow', function (e) { if (e.persisted) { close(true); side.hidden = true; } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();